import './modal-uploading.scss';

export default class 	ModalUploadingController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/file-upload').default[]} files
	 */
	constructor($uibModalInstance, files) {
		this.$uibModalInstance = $uibModalInstance;
		this.files = files;
	}

	/**
	 * Rounds a given value to two decimal places.
	 *
	 * @param {number} value - The number to be rounded.
	 * @returns {number} - The rounded number.
	 */
	round(value) {
		return Math.round(value * 100) / 100;
	}

	close() {
		return this.$uibModalInstance.dismiss();
	}

	/**
	 *
	 * @param {import('~/scripts/services/model/file-upload').default} file
	 */
	cancel(file) {
		file.cancel();
	}
}
